import React from "react";
import AllLocationsContainer from "../../container/allLocations";

const AllLocationsScreen: React.FC<{}> = () => {
    return <AllLocationsContainer/>;
}

export default AllLocationsScreen;